import { useContext } from 'react';
import { AerosyncPreAuthContext } from '../context/aerosync-pre-auth-provider';
import { AerosyncPreAuthContextType } from '../types';

export const useAerosyncPreAuthContext = (): AerosyncPreAuthContextType => {
  const context = useContext(AerosyncPreAuthContext);
  if (!context) {
    throw new Error('useAerosyncPreAuth must be used within an AerosyncPreAuthProvider');
  }
  return context;
};
